/* ============================================================
   perfectwhitetee — wholesale inquiry form wizard
   Vanilla JS, no dependencies. Posts to Shopify's contact endpoint
   via the standard {% form 'contact' %} markup; this script only
   handles step navigation, validation, chip toggles, conditional
   fields, and progress bar updates.
   ============================================================ */

(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pwtInited === '1') return;
    root.dataset.pwtInited = '1';

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-pwt-step]'));
    if (!steps.length) return;
    var totalSteps = steps.length;

    var progressFill  = root.querySelector('[data-pwt-progress-fill]');
    var progressLabel = root.querySelector('[data-pwt-progress-label]');
    var progressStep  = root.querySelector('[data-pwt-progress-step]');
    var stepNames     = {};
    steps.forEach(function (s) { stepNames[s.dataset.pwtStep] = s.dataset.pwtStepName || ''; });

    var nextBtns   = root.querySelectorAll('[data-pwt-next]');
    var prevBtns   = root.querySelectorAll('[data-pwt-prev]');
    var submitBtn  = root.querySelector('[data-pwt-submit]');
    var bizTypeSel = root.querySelector('[name="contact[Business type]"]');
    var conditional = {
      storeCount:   root.querySelectorAll('[data-pwt-show-when="has-stores"]'),
      marketplaces: root.querySelectorAll('[data-pwt-show-when="is-online"]')
    };
    var STORES_TYPES = ['independent boutique', 'multi-brand retailer', 'department store'];

    /* ---------- prefill businessType from ?type= ---------- */
    var qp = new URLSearchParams(window.location.search);
    var typeQp = (qp.get('type') || '').toLowerCase();
    if (typeQp === 'retailer' && bizTypeSel) bizTypeSel.value = 'independent boutique';
    if (typeQp === 'online'   && bizTypeSel) bizTypeSel.value = 'online store';

    /* ---------- chips ---------- */
    var chipGroups = root.querySelectorAll('[data-pwt-chips]');
    chipGroups.forEach(function (group) {
      var multi   = group.dataset.pwtChips === 'multi';
      var hidden  = group.querySelector('input[type="hidden"]');
      var chips   = group.querySelectorAll('[data-pwt-chip]');
      var current = (hidden && hidden.value) ? hidden.value.split('|').filter(Boolean) : [];

      function syncDom() {
        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', current.indexOf(c.dataset.pwtChip) !== -1 ? 'true' : 'false');
        });
        if (hidden) hidden.value = current.join(', ');
      }

      chips.forEach(function (c) {
        c.addEventListener('click', function (e) {
          e.preventDefault();
          var v = c.dataset.pwtChip;
          if (multi) {
            var i = current.indexOf(v);
            if (i === -1) current.push(v); else current.splice(i, 1);
          } else {
            current = [v];
          }
          syncDom();
          var err = group.parentNode.querySelector('[data-pwt-error]');
          if (err) err.textContent = '';
        });
      });
      syncDom();
    });

    /* ---------- conditional fields ---------- */
    function syncConditional() {
      var bt = bizTypeSel ? bizTypeSel.value : '';
      var showStores = STORES_TYPES.indexOf(bt) !== -1;
      var showMarkets = bt === 'online store';
      conditional.storeCount.forEach(function (el) { el.hidden = !showStores; });
      conditional.marketplaces.forEach(function (el) { el.hidden = !showMarkets; });
    }
    if (bizTypeSel) bizTypeSel.addEventListener('change', syncConditional);
    syncConditional();

    /* ---------- step navigation ---------- */
    var current = 1;

    function showStep(n) {
      current = n;
      steps.forEach(function (s) {
        s.hidden = parseInt(s.dataset.pwtStep, 10) !== n;
      });
      if (progressFill)  progressFill.style.width = Math.round((n / totalSteps) * 100) + '%';
      if (progressLabel) progressLabel.textContent = 'step ' + n + ' of ' + totalSteps;
      if (progressStep)  progressStep.textContent = stepNames[n] || '';

      // Show/hide nav buttons
      prevBtns.forEach(function (b) { b.hidden = n === 1; });
      nextBtns.forEach(function (b) { b.hidden = n === totalSteps; });
      if (submitBtn) submitBtn.hidden = n !== totalSteps;

      try {
        var top = root.getBoundingClientRect().top + (window.scrollY || document.documentElement.scrollTop) - 20;
        window.scrollTo({ top: top, behavior: 'smooth' });
      } catch (e) {}
    }

    function clearErrors(stepEl) {
      var errs = stepEl.querySelectorAll('[data-pwt-error]');
      errs.forEach(function (e) { e.textContent = ''; });
      var bad = stepEl.querySelectorAll('[aria-invalid="true"]');
      bad.forEach(function (e) { e.removeAttribute('aria-invalid'); });
    }

    function setError(stepEl, name, msg) {
      var field = stepEl.querySelector('[name="' + name + '"]');
      if (field) field.setAttribute('aria-invalid', 'true');
      var slot = stepEl.querySelector('[data-pwt-error-for="' + name + '"]');
      if (slot) slot.textContent = msg;
    }

    function validateStep(n) {
      var stepEl = steps[n - 1];
      clearErrors(stepEl);
      var ok = true;
      var required = stepEl.querySelectorAll('[data-pwt-required]');
      required.forEach(function (f) {
        var name = f.getAttribute('name') || f.getAttribute('data-pwt-required-name') || '';
        var val = '';
        if (f.tagName === 'INPUT' && f.type === 'checkbox') val = f.checked ? '1' : '';
        else val = (f.value || '').trim();
        if (!val) {
          setError(stepEl, name, f.dataset.pwtMsgRequired || 'this is required');
          ok = false;
        } else if (f.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val)) {
          setError(stepEl, name, 'that email doesn’t look right');
          ok = false;
        }
      });
      return ok;
    }

    nextBtns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (!validateStep(current)) return;
        if (current < totalSteps) showStep(current + 1);
      });
    });
    prevBtns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (current > 1) showStep(current - 1);
      });
    });

    // Intercept Enter-key inside text inputs before the final step so the
    // browser doesn't submit a partially-filled form. Textareas keep their
    // newline behavior.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var tag = (e.target.tagName || '').toUpperCase();
      if (tag === 'TEXTAREA') return;
      if (current < totalSteps) {
        e.preventDefault();
        var nextBtn = root.querySelector('[data-pwt-next]:not([hidden])');
        if (nextBtn) nextBtn.click();
      }
    });

    // Final submit: validate the final step, stash personalization for the
    // thanks page, then let the form post natively.
    var form = root.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!validateStep(totalSteps)) {
          e.preventDefault();
          return false;
        }
        // honeypot — if filled, abort silently
        var hp = form.querySelector('.pwt-hp input');
        if (hp && hp.value) {
          e.preventDefault();
          return false;
        }
        // Stash for the thanks page (5 min TTL).
        try {
          var nameInput = form.querySelector('[name="contact[name]"]');
          var typeInput = form.querySelector('[name="contact[Business type]"]');
          sessionStorage.setItem('pwtWholesaleSubmit', JSON.stringify({
            name: nameInput ? nameInput.value : '',
            type: typeInput ? typeInput.value : '',
            ts:   Date.now()
          }));
        } catch (err) { /* private browsing, ignore */ }
      });
    }

    showStep(1);
  }

  function boot() {
    document.querySelectorAll('[data-pwt-wizard]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
